export const EMAIL_TITLE = "New email";
export const ADDRESS_TITLE = "New address";
export const PHONE_TITLE = "New phone number";
